/* KonpreShop · SportShop disciplinas (2-nov-2026): las personas suben a su puerta al entrar en pantalla.
   Sin librerías; corre una sola vez; con «reducir movimiento» no hace nada (todo se ve desde el inicio). */
(function () {
  if (window.__ksUs) return; window.__ksUs = true;
  function setup(sec) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var doors = sec.querySelectorAll('.ks-us-dc__door');
    sec.classList.add('is-armed');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = e.target, i = Array.prototype.indexOf.call(doors, d) % 3;
        var img = d.querySelector('.ks-us-dc__fig img');
        if (img) img.style.transitionDelay = (i * 80) + 'ms';
        d.classList.add('is-in'); io.unobserve(d);
        setTimeout(function () { if (img) img.style.transitionDelay = ''; }, 1000);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    Array.prototype.forEach.call(doors, function (d) {
      var r = d.getBoundingClientRect();
      if (r.top < innerHeight * .88 && r.bottom > 0) d.classList.add('is-in'); else io.observe(d);
    });
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-ks-us-doors]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
